export const getWidth = (width) => {
    switch (width) {
        case "small":
            return "160px";
        case "medium":
            return "220px";
        case "large":
            return "300px";
        case "full":
            return "100%";
        default:
            return "100%";
    }
};
const remainder = (dividend, divisor) => ((dividend % divisor) + divisor) % divisor;
export const scrollIntoView = (element) => {
    if ("scrollBehavior" in window.document.documentElement.style) {
        element.scrollIntoView({ block: "nearest" });
        return;
    }
    const parent = element.parentElement;
    const { height, top } = element.getBoundingClientRect();
    const { top: parentTop } = parent.getBoundingClientRect();
    const offset = top - parentTop;
    if (offset < 0) {
        element.scrollIntoView(true);
    }
    else if (offset + height > parent.clientHeight) {
        element.scrollIntoView(false);
    }
};
export const findNextIndex = (index, options) => {
    const start = index === null ? 0 : index + 1;
    for (let i = start; i < start + options.length; i++) {
        const nextIndex = remainder(i, options.length);
        if (options[nextIndex]?.disabled !== true) {
            return nextIndex;
        }
    }
    return index;
};
export const findPrevIndex = (index, options) => {
    const start = index === null ? options.length - 1 : index - 1;
    for (let i = start; i > start - options.length; i--) {
        const nextIndex = remainder(i, options.length);
        if (options[nextIndex]?.disabled !== true) {
            return nextIndex;
        }
    }
    return index;
};
//# sourceMappingURL=select.js.map